import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../../styled-base/modal';
import BoardConst from '../../utils/constants/board';
import WorkstreamAutomation from './workstream';
import UserAutomation from './user';
import ColAutomationActionPopUpComp from './activity/col-automation-popup';
import Button from '../../../styled-base/button';

import './styles.scss';

interface AutomationModalProps {
    columnId: any;
    data: any,
    columnType: any,
    onClose: () => void,
    boardDetails?: any;
    dispatch?: any;
}

const AutomationModal = ({
    columnId,
    data,
    columnType,
    boardDetails,
    dispatch,
    onClose
}: AutomationModalProps) => {
    const { t } = useTranslation();
    const automationRef = useRef(null);
    const onReset = () => {
        if (automationRef.current) {
            automationRef.current.onReset();
        }
    }
    const onDone = () => {
        if (automationRef.current) {
            automationRef.current.onDone();
        }
    }

    const modalStyle: any = {
        width: '460px'
    };

    if (columnType == BoardConst.BOARD_DATATYPE_WORKSTREAMS) {
        modalStyle.minHeight = '480px';
        modalStyle.maxHeight = '500px';
    } else if (columnType == BoardConst.BOARD_DATATYPE_PEOPLE) {
        modalStyle.minHeight = '350px';
        modalStyle.maxHeight = '400px';
    } else if (columnType == BoardConst.BOARD_DATATYPE_ACTIONS) {
        modalStyle.maxHeight = '600px';
    }

    return (
        <Modal style={modalStyle}>
            <Modal.Header onClose={onClose}>
                <div>{t("Column Automation")}</div>
            </Modal.Header>
            <Modal.Content>
                {columnType == BoardConst.BOARD_DATATYPE_WORKSTREAMS
                    && <WorkstreamAutomation
                        columnId={columnId}
                        onClose={onClose}
                        ref={automationRef}
                        data={data}
                    />}
                {columnType == BoardConst.BOARD_DATATYPE_PEOPLE
                    && <UserAutomation
                        columnId={columnId}
                        onClose={onClose}
                        ref={automationRef}
                        data={data}
                    />}
                {columnType == BoardConst.BOARD_DATATYPE_ACTIONS
                    && <ColAutomationActionPopUpComp
                        columnId={columnId}
                        onClose={onClose}
                        ref={automationRef}
                        srcVal="automation"
                        data={data}
                        boardDetails={boardDetails}
                        dispatch={dispatch}
                        t={t}
                    />}
            </Modal.Content>
            <Modal.Footer>
                <Button type="cancel" onClick={() => onReset()}>
                    {t("Reset")}
                </Button>
                <Button type="primary" onClick={() => onDone()}>
                    {t("Done")}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default AutomationModal;
